export class ApptProcModel {
    appt_proc_id: number
    appt_proc_code: string
    appt_doctor_slots: number

    constructor(
        appt_proc_id: number,
        appt_proc_code: string,
        appt_doctor_slots: number
    ) {
        this.appt_proc_id = appt_proc_id
        this.appt_proc_code = appt_proc_code
        this.appt_doctor_slots = appt_doctor_slots
    }
}